const actionTypes = {
  SetOrganizationMeta: 'meta/SET_ORGANIZATION_META',
  ResetMeta: 'meta/RESET_META',
  SetSecureEnabled: 'meta/SET_SECURE_ENABLED',
}

const initialState = {
  hasValidSubscription: null,
  chargebeeId: null,
  hasValidM365LicensingReportSubscription: null,
  hasValidPostureBaselineSubscription: null,
  hasMultiCspSubscription: null,
  hasMfaOnlySubscription: null,
  hasEngageAutopilotSubscription: null,
  hasIntuneSubscription: null,
  hasPurviewSubscription: null,
  organizationObject: null,
  cloudallyUrl: null,
  securityTrainingUrl: null,
  secureEnabled: null,
  securePremiumEnabled: null,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetOrganizationMeta:
      return { ...state, ...action.payload }
    case actionTypes.ResetMeta:
      return initialState
    case actionTypes.SetSecureEnabled:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export const actions = {
  setOrganizationMeta: (payload) => ({
    type: actionTypes.SetOrganizationMeta,
    payload,
  }),
  resetMeta: () => ({
    type: actionTypes.ResetMeta,
  }),
  setSecureEnabled: (payload) => ({
    payload,
    type: actionTypes.SetSecureEnabled,
  }),
}
